import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  filter: {
    width: '100%',
    background: 'white',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1) / 2,
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'end',
  },
  wrapperButtonSubmitFiltes: {
    marginTop: 24,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',

    '& button': {
      '& span.material-icons': {
        marginRight: 4,
        fontSize: 18,
      },
    },
  },

  progressButtonFilter: {
    marginRight: 8,
  },
}));

export default styles;
